import { render, staticRenderFns } from "./previewable.vue?vue&type=template&id=2bcb777f&"
import script from "./previewable.vue?vue&type=script&lang=js&"
export * from "./previewable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports